import React, { Component } from 'react';
import { Text, View, ScrollView, Switch, Image } from 'react-native';
import { styles } from '../../constants/styles';
import Utils from '../../utils';
import SelectionList from '../components/selection_list';
import { getUIEventTypeNames } from './event_UI_helpers';
import OPComponent from '../components/op_component';

export default class SelectEventTypeName extends OPComponent {
  constructor(props) {
    super(props);

    let eventTypeNames = getUIEventTypeNames();

    this.state = {
      items: eventTypeNames,
    };
  }

  componentDidMount() {
    Utils.trackScreen('Calendar', 'Event Type Name Sheet');
  }

  render() {
    return (
      <View style={styles.containerAlt}>
        <ScrollView alwaysBounceVertical={false} contentContainerStyle={styles.scrollViewContent}>
          <SelectionList
            items={this.state.items}
            selectedId={this.props.eventTypeName}
            onSelect={this.props.onSelect}
          />
        </ScrollView>
      </View>
    );
  }
}
